var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.variant)?_c(_vm.comp,{tag:"component"}):_c('div',{staticStyle:{"min-height":"60vh"}})}
var staticRenderFns = []

export { render, staticRenderFns }